// src/components/FeedSkeleton.jsx
"use client";

import CardSkeleton from "@/components/CardSkeleton";

export default function FeedSkeleton({ count = 3 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, idx) => (
        <CardSkeleton key={idx} />
      ))}
    </div>
  );
}
